import { PropsWithChildren, createContext } from "react";
import { useKYCMerchantId } from "../KYCSettingsProvider";
import useFetchPaymentMethods from "./useFetchPaymentMethods";

export const IncludeMethodsContext = createContext({} as ReturnType<typeof useFetchPaymentMethods>);

const IncludeMethodsProvider = ({ children }: PropsWithChildren) => (
    <IncludeMethodsContext.Provider
        value={useFetchPaymentMethods({
            merchantId: useKYCMerchantId()
        })}
    >
        {children}
    </IncludeMethodsContext.Provider>
);

export default IncludeMethodsProvider;
